import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\ServeAdController::index
* @see app/Http/Controllers/Api/ServeAdController.php:28
* @route '/api/ad'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/api/ad',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\ServeAdController::index
* @see app/Http/Controllers/Api/ServeAdController.php:28
* @route '/api/ad'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\ServeAdController::index
* @see app/Http/Controllers/Api/ServeAdController.php:28
* @route '/api/ad'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\ServeAdController::index
* @see app/Http/Controllers/Api/ServeAdController.php:28
* @route '/api/ad'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

const ServeAdController = { index }

export default ServeAdController